import styled from 'styled-components';

export const Element = styled.div`
  text-align: center;
  background: #16345938;
  padding: 24px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: none;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.15);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(26, 26, 46, 0.25);
    transform: translateY(-4px);
  }

  h1 {
    font-size: 20px;
    font-weight: 600;
    margin-top: 15px;
    color: #1a1a2e;
    line-height: 1.3;
    text-align: left;
    width: 100%;
  }

  small {
    color: #4b5563;
    font-size: 12px;
    margin: 8px 0;
    display: block;
  }

  .incident-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 12px;
  }

  .incident-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .incident-number {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a2e;
    background: rgba(26, 26, 46, 0.1);
    padding: 4px 8px;
    border-radius: 6px;
    margin-bottom: 8px;
  }

  .incident-date {
    color: #6b7280;
    font-size: 11px;
  }

  .incident-description {
    color: #6b7280;
    font-size: 13px;
    line-height: 1.4;
    margin: 12px 0;
    text-align: left;
    flex-grow: 1;
    width: 100%;
  }

  .incident-details {
    width: 100%;
    margin-top: auto;
    
    .detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
      font-size: 12px;
      
      .label {
        color: #6b7280;
        font-weight: 500;
      }
      
      .value {
        color: #374151;
        font-weight: 600;
      }
    }
  }

  .badges-container {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: flex-start;
  }

  .badge {
    font-size: 10px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .badge-severity {
    &.BAIXA { background: #d1fae5; color: #065f46; }
    &.MEDIA { background: #fef3c7; color: #92400e; }
    &.ALTA { background: #fee2e2; color: #991b1b; }
    &.CRITICA { background: #f3f4f6; color: #374151; }
  }

  .badge-status {
    &.ABERTO { background: #fee2e2; color: #991b1b; }
    &.EM_ANALISE { background: #fef3c7; color: #92400e; }
    &.CONCLUIDO { background: #d1fae5; color: #065f46; }
    &.ARQUIVADO { background: #6b7280; color: #ffffff; }
  }

  .actions-container {
    display: flex;
    gap: 8px;
    margin-top: 16px;
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .action-button {
    background: rgba(26, 26, 46, 0.1);
    border: 1px solid rgba(26, 26, 46, 0.2);
    color: #1a1a2e;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 4px;
    text-decoration: none;

    &:hover {
      background: #1a1a2e;
      color: white;
      transform: translateY(-1px);
    }

    &.primary:hover { background: #1a1a2e; }
    &.secondary:hover { background: #6b7280; }
    &.danger:hover { background: #dc2626; }
    &.info:hover { background: #0891b2; }
  }
`;

export const ContainerProgress = styled.aside`
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 2;
`;
